import { leadSourceIdentification, getDeviceType, getSlug, fetchPathNameForLeadSource, blockOnLeadSource } from "../utils";

export async function postFetcher(url, { arg }) {
  try {
    const leadDir = typeof leadSourceIdentification === "function" ? leadSourceIdentification() : null;
    const { path } = fetchPathNameForLeadSource();
    const directorySlug = typeof getSlug === "function"? getSlug() : null;
    const deviceType = typeof getDeviceType ? getDeviceType() : null;
    const payload = { ...arg };

    if (!blockOnLeadSource.includes(path) && leadDir && payload?.data && typeof payload.data === 'object') {
      payload.data = { ...payload.data, leadDir };
    }
    if (directorySlug && payload?.data && typeof payload.data === 'object') {
      payload.data = { ...payload.data, directorySlug };
    }
    if (deviceType && payload?.data && typeof payload.data === 'object') {
      payload.data = { ...payload.data, deviceType };
    }
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Fetch Post Error:", error);
    throw error.message;
  }
}

export async function getFetcher(url) {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Fetch Get Error:", error);
    throw error.message;
  }
}

export async function deleteFetcher(url, { arg }) {
  try {
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(arg),
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Fetch Post Error:", error);
    throw error.message;
  }
}
